module.exports = __webpack_public_path__ + "img/logo.dd61cfff.png";